import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import ButtonGroup from '@material-ui/core/ButtonGroup/ButtonGroup';
import Typography from '@material-ui/core/Typography';
import {
  TableFieldToolbarButton,
  TableFieldToolbarProps,
} from '@eas/common-web';
import ControlPointIcon from '@material-ui/icons/ControlPoint';
import RemoveIcon from '@material-ui/icons/Delete';
import { useAssignAgendaDialog } from '../dialog-actions/assign-agenda-hook';
import { useUnassignAgendaDialog } from '../dialog-actions/unassign-agenda-hook';

export const useStyles = makeStyles((theme) => ({
  textButton: {
    fontSize: 14,
    fontWeight: 600,
  },
  tableActions: {
    justifyContent: 'space-between',
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
    // height: 30,
    width: '100%',
    boxSizing: 'border-box',
    verticalAlign: 'top',
    display: 'flex',
    padding: '0 16px',
    '& svg': {
      cursor: 'pointer',
      width: 20,
      height: 20,
      padding: '2pt',
    },
  },
  buttonGroup: {
    display: 'flex',
    marginBottom: 8,
    // marginLeft: -5, // offset first icon left padding

    '& button:not(:last-of-type)': {
      borderRight: `1px solid ${theme.palette.grey['400']}`,
    },
  },
}));

export function SubjectsAgendasToolbar({
  selectedIndex,
  setSelectedIndex,
}: TableFieldToolbarProps) {
  const classes = useStyles();

  const { handleAssignAgenda, canAssign } = useAssignAgendaDialog();
  const { handleUnassignAgenda, canUnassign } = useUnassignAgendaDialog({
    selectedIndex: selectedIndex!,
    setSelectedIndex,
  });

  return (
    <div className={classes.tableActions}>
      <ButtonGroup className={classes.buttonGroup}>
        <TableFieldToolbarButton
          color="primary"
          variant="contained"
          title="Přiřazení agendy subjektu"
          disabled={!canAssign || selectedIndex !== undefined}
          show={true}
          IconComponent={ControlPointIcon}
          onClick={handleAssignAgenda}
        >
          <Typography variant="body2">Přidat</Typography>
        </TableFieldToolbarButton>
        <TableFieldToolbarButton
          color="secondary"
          variant="text"
          IconComponent={RemoveIcon}
          disabled={!canUnassign || selectedIndex === undefined}
          show={true}
          title="Zrušení agendy subjektu"
          onClick={handleUnassignAgenda}
        >
          <Typography variant="body2">Zrušit</Typography>
        </TableFieldToolbarButton>
      </ButtonGroup>
    </div>
  );
}
